import Modal from 'common/components/modal/Modal';
import PropTypes from 'prop-types';

const UnmetRequirementsModal = ({
    handleClose,
    unmetRequirementsList,
    UnmetRequirementsHeader,
}) => {
    return (
        <Modal
            onCloseClick={handleClose}
            header={<span>REQUIREMENTS {UnmetRequirementsHeader()}</span>}
            showClose
        >
            {unmetRequirementsList}
        </Modal>
    );
};

UnmetRequirementsModal.propTypes = {
    handleClose: PropTypes.func.isRequired,
    unmetRequirementsList: PropTypes.arrayOf(PropTypes.element).isRequired,
    UnmetRequirementsHeader: PropTypes.func.isRequired,
};

export default UnmetRequirementsModal;
